<div class="add-container">
    <h1 class="add-title">Adaugă slot blocare</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Dată început</mat-label>
                    <input matInput [matDatepicker]="dataFromPicker" formControlName="date_from" readonly
                        (focus)="dataFromPicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dataFromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dataFromPicker></mat-datepicker>
                    <mat-error *ngIf="!form.controls['date_from'].valid && form.controls['date_from'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Oră început</mat-label>
                    <input [ngxMatTimepicker]="fromTimepicker" matInput formControlName="time_from" [format]="24"
                        readonly />
                    <ngx-mat-timepicker color="primary" #fromTimepicker></ngx-mat-timepicker>
                    <mat-error *ngIf="!form.controls['time_from'].valid && form.controls['time_from'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Dată sfârșit</mat-label>
                    <input matInput [matDatepicker]="dataEndPicker" formControlName="date_end" readonly
                        (focus)="dataEndPicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dataEndPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dataEndPicker></mat-datepicker>
                    <mat-error *ngIf="!form.controls['date_end'].valid && form.controls['date_end'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Oră sfârșit</mat-label>
                    <input [ngxMatTimepicker]="endTimepicker" matInput formControlName="time_end" [format]="24"
                        readonly />
                    <ngx-mat-timepicker color="primary" #endTimepicker></ngx-mat-timepicker>
                    <mat-error *ngIf="!form.controls['time_end'].valid && form.controls['time_end'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>